<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>

</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'

const { locale } = useI18n()

const elementLocales = {
  zh: zhCn,
  en: en
}
// 绑定 Element Plus 当前语言
const elementLocale = computed(() => elementLocales[locale.value as 'zh' | 'en'])
</script>

<style>
body {
  padding: 0;
  max-width: 3200px;
  min-width: 320px;
  margin: auto;
  box-sizing: border-box;
}
</style>
